export default "__VITE_ASSET__2fb63848__"